import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";

type FetchingTypeData = {
    total_net_profit: number,
    location_net_profit: {
        location_id: number,
        location_name: string,
        net_profit_margin: number
    }[]
}

export function useEffeciency({ date, location_id }: { date: string, location_id: string | undefined}) {
    const api = useApi();

    const [data, setData] = useState<FetchingTypeData | null>(null);

    const params: Record<string, string | number> = {
        yearmonth: date,
    };

    if (location_id) {
        params.location_id = location_id;
    }

    const fetchUrl = () => {
        return api.get(`/dashboard/efficiency/net-profit-margin`, { params })
    }

    const fetchData = () => {
        fetchUrl().then((res: SuccessFetch<{
            payload: FetchingTypeData
        }>) => {
            setData(res.data.payload);
        }).catch(() => {
            setData(null);
        })
    }

    useEffect(() => {
        fetchData();
        return () => {
            setData(null);
        }
        // eslint-disable-next-line
    }, [date, location_id]);
    return { fetchData, data }
}


type NetProfitMarginType = {
    gross_profit_margin: number,
    revenue: number
}

export function useGrossProfitMargin({ date, location_id }: { date: string, location_id: string | undefined}) {
    const api = useApi();

    const [data, setData] = useState<NetProfitMarginType | null>(null);

    const params: Record<string, string | number> = {
        yearmonth: date,
    };

    if (location_id) {
        params.location_id = location_id;
    }

    const fetchUrl = () => {
        return api.get(`/dashboard/efficiency/gross-profit-margin`, { params })
    }

    const fetchData = () => {
        fetchUrl().then((res: SuccessFetch<{
            payload: NetProfitMarginType
        }>) => {
            setData(res.data.payload);
        }).catch(() => {
            setData(null);
        })
    }

    useEffect(() => {
        fetchData();
        return () => {
            setData(null);
        }
        // eslint-disable-next-line
    }, [date, location_id]);
    return { fetchData, data }
}

